import React from 'react'
import { TitleBar, TitleAction, TitleContent } from '@pga/pga-component-library'
import { formatCurrency, formatDate } from '../../../../helpers'
import { Spinner, Table } from 'reactstrap'
import { LINE_ITEMS_BY_INVOICE_NUMBER } from '../../../../queries/invoices'
import { useQuery } from 'react-apollo'

const InvoiceDetailTable = ({
  data: {
    dueDt,
    invoiceNum: invoiceNumber
  },
  tableMapping,
  isOpen
}) => {
  const [details, setDetails] = React.useState([])
  const skip = !isOpen || details.length > 0
  const { data, loading, error } = useQuery(LINE_ITEMS_BY_INVOICE_NUMBER, { variables: { invoiceNumber }, skip })

  React.useEffect(() => {
    if (data) {
      const { invoiceLineItemsByInvoiceNumber = [] } = data
      setDetails(invoiceLineItemsByInvoiceNumber)
    }
  }, [data])

  if (loading) return <div><Spinner color='secondary' /> Loading Invoice Line Items</div>
  if (error) return <div>Could not load invoice line items</div>

  const subtotal = details.reduce((acc, cv) => acc + parseFloat(cv.amount), 0.0)
  return (
    <div>
      <TitleBar>
        <TitleContent>
          <h5>Invoice: {invoiceNumber}</h5>
        </TitleContent>
        <TitleAction>
          <h5>Due: {formatDate(dueDt)}</h5>
        </TitleAction>
      </TitleBar>
      <Table>
        <thead>
          <tr>
            {
              tableMapping.map(({ label }) => (
                <th key={label}>{label}</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            details.map((inv, index) => (
              <tr key={index}>
                {
                  tableMapping.map(({ field, format }) => (
                    <td key={field}>{format(inv[field])}</td>
                  ))
                }
              </tr>
            ))
          }
        </tbody>
      </Table>
      <TitleBar>
        <TitleContent />
        <TitleAction>
          <h5>Subtotal: {formatCurrency(subtotal)}</h5>
        </TitleAction>
      </TitleBar>
    </div>
  )
}

export default InvoiceDetailTable
